import { Link } from "react-router-dom";
import { ArrowUpRight, ChevronDown } from "lucide-react";
import { APOLOGETICS_DOGMAS } from "@/data/apologeticsQuestions";

export const SourceLinks = ({ items, prefix }) => (
  <ul className="mt-5 flex flex-wrap gap-x-5 gap-y-3" data-testid={`${prefix}-sources`}>
    {items.map((item, i) => <li key={`${item.label}-${i}`} className="min-w-0 max-w-full">
      <a href={item.url} target="_blank" rel="noopener noreferrer" data-testid={`${prefix}-source-${i}`} className="inline-flex max-w-full items-start gap-1 text-xs leading-relaxed text-marian underline decoration-marian/30 underline-offset-4 transition-colors hover:text-gold"><span className="break-words">{item.label}</span><ArrowUpRight size={13} className="mt-0.5 shrink-0" aria-hidden="true" /></a>
    </li>)}
  </ul>
);

export const TeachingChapter = ({ id, number, title, children }) => (
  <section id={id} data-testid={`apologetics-${id}`} className="scroll-mt-28 border-t border-marian/15 py-12 first:border-0 first:pt-0 sm:py-16">
    <p className="font-mono text-xs uppercase text-gold" data-testid={`${id}-chapter-label`}>Chapter {number}</p>
    <h2 className="mt-3 font-serif text-base font-semibold text-midnight md:text-lg" data-testid={`${id}-heading`}>{title}</h2>
    <div className="mt-7 space-y-6 text-sm leading-relaxed text-charcoal/90 sm:text-base">{children}</div>
  </section>
);

export const DogmaSummary = () => (
  <div className="divide-y divide-marian/15 border-y border-marian/15" data-testid="dogma-list">
    {APOLOGETICS_DOGMAS.map((d, i) => <details key={d.id} open={i === 0 ? true : undefined} className="group py-5" data-testid={`dogma-${d.id}`}>
      <summary data-testid={`dogma-toggle-${d.id}`} className="flex cursor-pointer list-none items-start gap-3 text-midnight transition-colors hover:text-marian [&::-webkit-details-marker]:hidden">
        <span className="font-mono text-xs text-gold">0{i + 1}</span>
        <span className="min-w-0 flex-1"><span className="block font-serif text-xl font-semibold">{d.title}</span><span className="mt-1 block text-xs text-slateblue">{d.date}</span></span>
        <ChevronDown size={18} className="shrink-0 transition-transform group-open:rotate-180" />
      </summary>
      <div className="pt-5" data-testid={`dogma-content-${d.id}`}>
        <p>{d.text}</p><SourceLinks items={d.refs} prefix={`dogma-${d.id}`} />
        <Link to={`/dogmas/${d.slug}`} data-testid={`dogma-guide-${d.id}`} className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-marian transition-colors hover:text-gold">Read the full dogma guide<ArrowUpRight size={15} /></Link>
      </div>
    </details>)}
  </div>
);